/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternetRegistrationMatchResponse
 */
export interface InternetRegistrationMatchResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InternetRegistrationMatchResponse
     */
    lastName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternetRegistrationMatchResponse
     */
    firstName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternetRegistrationMatchResponse
     */
    birthday: boolean;
}

/**
 * Check if a given object implements the InternetRegistrationMatchResponse interface.
 */
export function instanceOfInternetRegistrationMatchResponse(value: object): value is InternetRegistrationMatchResponse {
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    return true;
}

export function InternetRegistrationMatchResponseFromJSON(json: any): InternetRegistrationMatchResponse {
    return InternetRegistrationMatchResponseFromJSONTyped(json, false);
}

export function InternetRegistrationMatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternetRegistrationMatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'birthday': json['birthday'],
    };
}

export function InternetRegistrationMatchResponseToJSON(json: any): InternetRegistrationMatchResponse {
    return InternetRegistrationMatchResponseToJSONTyped(json, false);
}

export function InternetRegistrationMatchResponseToJSONTyped(value?: InternetRegistrationMatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'birthday': value['birthday'],
    };
}

